/* eslint-disable camelcase */
import classNames from "classnames";
import { compact } from "lodash";
import AppContext from "PFApp/app_context";
import CustomValuesList from "PFComponents/custom_values_list/custom_values_list";
import Hr from "PFComponents/hr";
import { Typography } from "PFComponents/typography";
import { useMatchableTypes } from "PFCore/helpers/activities";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { Activity } from "PFTypes";
import React, { useContext } from "react";

import css from "./activity_details_common.module.scss";

type ActivityDetailsSkillsProps = {
  task: Activity;
};

export const ActivityDetailsSkills = ({ task }: ActivityDetailsSkillsProps): JSX.Element | null => {
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  const { data: currentProfile } = useCurrentProfile();
  const matchableTypes = useMatchableTypes(task.template_id);
  const skillsType = currentProfile.custom_types.find(({ name }) => name === "skills");

  const customFields = compact(
    task.custom_fields.map((customField) => {
      const matchableType = matchableTypes.find(({ name }) => name === customField.type?.name);
      if (matchableType && (customField.values || []).length > 0) {
        return { ...customField, customType: matchableType };
      } else {
        return null;
      }
    })
  );

  return customFields.length > 0 ? (
    <>
      <div className={classNames(css.bigItem)} data-qa-id="ActivityDetailsSkills">
        {customFields.map((customField) => (
          <div key={customField.type.id} className={css.itemContainer}>
            <Typography variant="h5" noMargin>
              {customField.customType.title}
            </Typography>
            <CustomValuesList
              type={skillsType}
              currentProfile={currentProfile}
              currentAccount={currentAccount}
              customValues={customField.values}
            />
          </div>
        ))}
      </div>
      <Hr />
    </>
  ) : null;
};
